import { useState, useEffect } from 'react';
import styles from './index.module.sass';
import Button from 'componets/button';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const TransferInformation = ({ title, indent, onCopy }) => {
  const CopyButton = () => {
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
      let hideCopied;
      if (isCopied) {
        hideCopied = setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      }
      return () => {
        clearTimeout(hideCopied);
      };
    }, [isCopied]);

    const copiedClass = cx({
      copied: true,
      show: isCopied,
    });

    return (
      <CopyToClipboard
        text="02312104523"
        onCopy={() => {
          if (onCopy) onCopy();
          setIsCopied(true);
        }}
      >
        <Button variant="text" classname={styles.button}>
          複製
          <div className={copiedClass}>已複製</div>
        </Button>
      </CopyToClipboard>
    );
  };

  return (
    <>
      {title && <div className={styles.title}>{title}</div>}
      <ul className={styles.account}>
        <li>戶頭名稱：麻吉行得通股份有限公司</li>
        <hr style={{ width: '1005' }} />
        <li className={styles.number}>
          <div className={styles.text}>
            <div>帳戶號碼</div>
            <div>007 09 16116 0</div>
          </div>
          <CopyButton />
        </li>
        <hr style={{ width: '1005' }} />
        <li className={styles.bank}>
          <div className={styles.text}>
            <div>銀行代號：兆豐國際商業銀行（國外部）</div>
            <div>017（0077）</div>
          </div>
        </li>
      </ul>
      <p className={styles.content}>
        轉帳成功後，請點擊「通知已轉帳」按鈕完成表單送出通知。稍等 1 個工作天確認入帳，完成將以 Email 通知您已開通服務。
      </p>
    </>
  );
};

export default TransferInformation;
